/**
 * Site-wide settings.
 *
 * The Archive and the Directory are one thing: the hero's Enter button goes
 * straight into the archive, where the section cards, the toolbar and the
 * records follow. Contact lives in the header bar and the footer; Nostr and
 * Resources live in the footer.
 */

/**
 * The archive's Bitcoin address on the Ordiscan explorer: where the Bitcoin row
 * in the Archive & Directory block sends readers. Change it here if the
 * explorer (or the address) ever changes.
 */
export const ORDISCAN_URL =
  'https://ordiscan.com/address/bc1prwdy4wcw8k7vlzrqdpwesew2fls9y2us472zj07u9wd2dmvckqhqwp9llt';

/**
 * How many inscriptions the archive holds on Bitcoin, shown on the Bitcoin
 * Inscriptions pill. This is typed in by hand, NOT read from the chain: it is
 * the count on Ordiscan, which is a different number from the records held on
 * this site. Update it here whenever new inscriptions are made.
 */
export const INSCRIPTION_COUNT = 53;

/**
 * Bitcoin Ordinals inscriptions for curated pager intercept releases.
 * These are permanently inscribed on the Bitcoin blockchain for decentralized preservation.
 */
export const PAGER_INSCRIPTIONS = {
  mediaMarketIsraeli: 'https://ordiscan.com/inscription/70787182',
  bombExplosion: 'https://ordiscan.com/inscription/71715607',
};
